/**
 * Sticky nákupní lišta na PDP – chování lišty ze snippets/pdp-sticky-lista.liquid (kreslí ji
 * sections/produkt-buybox.liquid a produkt-slzy-buybox.liquid; vzhled v
 * assets/component-buybox-sticky.css).
 *
 * Řeší:
 *   - viditelnost: lišta startuje skrytá (`hidden` v markupu) a odkryje se, jakmile hlavní ATC
 *     lištu (`data-observe-selector`) uživatel odscrolluje NAHORU pryč z viewportu
 *     (getBoundingClientRect().bottom < 0, měřeno při scrollu) – synchronizuje `hidden` i
 *     `aria-hidden`. Jen „není vidět" nestačí: stejně tak nastane, když ATC ještě nebylo dosaženo
 *     (je níž pod viewportem, typicky hned po loadu na mobilu) – tehdy lišta zůstává skrytá;
 *   - synchronizaci množství z hlavního selektoru (`data-qty-selector`) do skrytého inputu
 *     lišty ([data-sticky-qty]) a cenu lišty = cena varianty × množství, od `data-kura-n` kusů
 *     se slevou `data-kura-pct` (jen zobrazení, skutečnou slevu počítá košík);
 *   - změnu varianty (Dawn pubsub variantChange ze stejné sekce `data-section`): id varianty
 *     ve formuláři lišty, cena, stav vyprodáno; cena za jednotku platí jen pro výchozí variantu,
 *     po změně se schová;
 *   - rezervaci místa dole (--pdp-sticky-bar-h na body), aby fixed lišta na konci stránky
 *     nepřekrývala patičku; podle téže proměnné se nad lištu posadí šipka Na začátek (spodní dok);
 *   - schování plovoucí bubliny Poradny, dokud je lišta vidět (chat otevírá tlačítko v liště);
 *   - stav tlačítka Přidat do košíku (etapa 7 handoffu: přístupnost) – na rozdíl od hlavního ATC
 *     (snippets/buy-buttons.liquid → <product-form>, assets/product-form.js) je formulář lišty
 *     obyčejný nativní <form method="post" action="cart_add_url"> BEZ vlastního AJAX/fetch. Je-li na
 *     stránce cart-drawer/cart-notification, submit se předá hlavnímu <product-form> (requestSubmit),
 *     takže se otevře drawer stejně jako u hlavního ATC – bez duplikace fetch/cart-render logiky.
 *     Jinak se submit nepřerušuje a Shopify přesměruje na /cart; bez JS by tlačítko během
 *     zpracování neoznámilo žádný "loading" stav. Řešení níže: při submitu se tlačítku nastaví
 *     aria-disabled (ne `disabled` – to by při zaostřeném tlačítku mohlo zahodit fokus, stejná
 *     konvence jako product-form.js) a text se přepne na "adding" popisek z data-label-adding.
 *     Úspěch/chyba řeší dál samotná navigace prohlížeče (nová stránka = jednoznačný signál i pro
 *     čtečku); pageshow reset kryje návrat přes tlačítko Zpět / bfcache, kde by jinak zůstal
 *     "zaseklý" busy stav.
 */
(function () {
  function initStickyForm(bar, target) {
    var form = bar.querySelector('.pdp-sticky-bar__form');
    var btn = form ? form.querySelector('.pdp-sticky-bar__btn') : null;
    if (!form || !btn) return;
    var labelAdding = btn.getAttribute('data-label-adding') || btn.textContent;
    function reset() {
      btn.removeAttribute('aria-disabled');
      btn.textContent = btn.disabled ? bar.dataset.labelSoldout : bar.dataset.labelAdd;
    }
    form.addEventListener('submit', function (evt) {
      if (btn.getAttribute('aria-disabled') === 'true') { evt.preventDefault(); return; }
      // Je-li v motivu košík jako drawer/notifikace, předá se odeslání hlavnímu <product-form>
      // (AJAX + otevření draweru, aktuálně vybraná varianta i množství). Nativní odeslání níže
      // zůstává jen jako záloha – Shopify po něm přesměruje na celostránkový /cart.
      var mainForm = target ? target.querySelector('product-form form') : null;
      var cartUi = document.querySelector('cart-drawer, cart-notification');
      if (mainForm && cartUi && typeof mainForm.requestSubmit === 'function') {
        evt.preventDefault();
        mainForm.requestSubmit();
        return;
      }
      btn.setAttribute('aria-disabled', 'true');
      btn.textContent = labelAdding;
      // NepreventDefault – nativní odeslání formuláře pokračuje normálně, jen s viditelným
      // busy stavem po dobu round-tripu na server.
    });
    // bfcache/tlačítko Zpět: stránka se obnoví se starým DOM stavem (busy text by jinak zůstal).
    window.addEventListener('pageshow', reset);
  }

  function formatMoney(cents, moneyFormat) {
    if (!moneyFormat) return String(Math.round(cents / 100));
    function delim(num, precision, thousands, decimal) {
      num = (num / 100).toFixed(precision);
      var parts = num.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    var value;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = delim(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delim(cents, 2, '.', ','); break;
      case 'amount_with_space_separator': value = delim(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = delim(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_comma_separator': value = delim(cents, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': value = delim(cents, 0, ' ', ','); break;
      default: value = delim(cents, 2, ',', '.');
    }
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  // Cena lišty = cena varianty × množství, od kura_n kusů se slevou kura_pct; u jednoho kusu
  // zůstává cena z Liquidu (přesný formát obchodu).
  function initPrice(bar) {
    var qtyHidden = bar.querySelector('[data-sticky-qty]');
    var priceEl = bar.querySelector('[data-sticky-price]');
    var kuraEl = bar.querySelector('[data-sticky-kura-note]');
    var n = parseInt(bar.dataset.kuraN, 10) || 0;
    var pct = parseInt(bar.dataset.kuraPct, 10) || 0;
    var kuraNote = bar.dataset.kuraNote || '';
    var moneyFormat = (bar.dataset.moneyFormat || '').replace(/<[^>]*>/g, '');
    var baseMoney = priceEl ? priceEl.textContent : '';
    var baseUnit = parseInt(bar.dataset.unitPrice, 10) || 0;
    function recompute() {
      var unit = parseInt(bar.dataset.unitPrice, 10) || 0;
      var q = qtyHidden ? Math.max(1, parseInt(qtyHidden.value, 10) || 1) : 1;
      if (q <= 1 || !unit) {
        if (priceEl && unit) priceEl.textContent = unit === baseUnit ? baseMoney : formatMoney(unit, moneyFormat);
        if (kuraEl) { kuraEl.hidden = true; kuraEl.textContent = ''; }
        return;
      }
      var total = unit * q;
      var hasKura = n > 1 && pct > 0 && q >= n;
      var pay = hasKura ? Math.round(total - total * pct / 100) : total;
      if (priceEl) priceEl.textContent = formatMoney(pay, moneyFormat);
      if (kuraEl) { kuraEl.hidden = false; kuraEl.textContent = hasKura ? kuraNote.replace('[q]', q).replace('[pct]', pct) : (q + '×'); }
    }
    if (qtyHidden) qtyHidden.addEventListener('change', recompute);
    return recompute;
  }

  // Změna varianty v buy boxu: Dawn product-info.js publikuje variantChange se sectionId.
  function initVariant(bar, recompute) {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    var idInput = bar.querySelector('[data-sticky-variant]');
    var btn = bar.querySelector('.pdp-sticky-bar__btn');
    var unitEl = bar.querySelector('[data-sticky-unit]');
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.variant || data.sectionId !== bar.dataset.section) return;
      var v = data.variant;
      if (idInput) idInput.value = v.id;
      bar.dataset.unitPrice = v.price;
      if (btn) {
        btn.disabled = !v.available;
        btn.removeAttribute('aria-disabled');
        btn.textContent = v.available ? bar.dataset.labelAdd : bar.dataset.labelSoldout;
      }
      if (unitEl) unitEl.hidden = true;
      recompute();
    });
  }

  function initBar(bar) {
    var observeSelector = bar.getAttribute('data-observe-selector');
    var qtySelector = bar.getAttribute('data-qty-selector');
    var target = observeSelector ? document.querySelector(observeSelector) : null;
    var mainQty = qtySelector ? document.querySelector(qtySelector) : null;
    var stickyQty = bar.querySelector('[data-sticky-qty]');
    initStickyForm(bar, target);
    var recompute = initPrice(bar);
    initVariant(bar, recompute);

    function updateSpacer() {
      var h = bar.hidden ? 0 : bar.offsetHeight;
      document.body.style.setProperty('--pdp-sticky-bar-h', h + 'px');
    }

    function syncQty() {
      if (!stickyQty) return;
      // Math.max(1, …) – ochrana proti záporné/nulové hodnotě z hlavního inputu (min="1" je jen
      // HTML atribut, ručně napsané "-5" ho neošetří); qtyHidden.value se pak posílá i do
      // cart_add_url formuláře lišty, proto musí být vždy platné kladné množství.
      var q = mainQty ? Math.max(1, parseInt(mainQty.value, 10) || 1) : 1;
      stickyQty.value = q;
      stickyQty.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (target) {
      // Poloha se měří při každém scrollu (přes rAF), ne IntersectionObserverem: ten hlásí jen
      // překročení prahu, takže rychlý scroll, který hlavní ATC přeskočí zpod viewportu rovnou
      // nad něj, lištu vůbec neodkryl. bottom < 0 = hlavní ATC už prošlo nahoře; pod viewportem
      // (ještě nedosažené, typicky hned po loadu na mobilu) lišta zůstává skrytá.
      var pending = false;
      var update = function () {
        pending = false;
        var show = target.getBoundingClientRect().bottom < 0;
        if (show === !bar.hidden) return;
        bar.hidden = !show;
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        // Dokud je lišta vidět, chat k produktu otevírá její tlačítko Poradny a plovoucí bublina appky
        // se schová (veřejná třída Notia Advisor; otevřený chat nezavře). ml-lista čte spodní dok.
        document.body.classList.toggle('notia-advisor-hide-launcher', show);
        document.body.classList.toggle('ml-lista', show);
        updateSpacer();
      };
      var schedule = function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(update);
      };
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      update();
    }

    // Výška lišty se může měnit (mobilní breakpoint skryje obrázek, přibude
    // řádek kúry nebo množství) – ResizeObserver na samotné liště pokryje oba případy, ne jen resize okna.
    if ('ResizeObserver' in window) {
      new ResizeObserver(updateSpacer).observe(bar);
    } else {
      window.addEventListener('resize', updateSpacer);
    }

    if (mainQty) {
      mainQty.addEventListener('change', syncQty);
      mainQty.addEventListener('input', syncQty);
    }
    syncQty();
  }

  function init() {
    document.querySelectorAll('[data-pdp-sticky-bar]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
